import { Box } from "@mui/material";
import React from "react";

import MDTypography from "@/components/atoms/MDTypography";

type Props = {
  content?: string | null;
  emptyText: string;
};

const ContentPreviewBubble = ({ content, emptyText }: Props) => {
  const text = content?.trim();

  return (
    <Box
      sx={{
        bgcolor: "#f0f2f5",
        borderRadius: "12px",
        p: 1.5,
        minHeight: 96,
        maxHeight: 180,
        overflowY: "auto",
        width: "100%",
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          left: -6,
          top: 18,
          width: 0,
          height: 0,
          borderTop: "6px solid transparent",
          borderBottom: "6px solid transparent",
          borderRight: "6px solid #ffffff",
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "#ffffff",
          borderRadius: "10px",
          p: 1.5,
          boxShadow: "0 1px 0.5px rgba(11,20,26,0.12)",
          minHeight: 64,
        }}
      >
        <MDTypography
          variant="button"
          color="text"
          sx={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block",
            color: text ? "#111b21" : "#667781",
          }}
        >
          {text || emptyText}
        </MDTypography>
      </Box>
    </Box>
  );
};

export default ContentPreviewBubble;
